import React, { useState } from 'react';
import './FAQ.css';

const faqs = [
  {
    question: "Is this an official Mica product?",
    answer: "No. This is an independent, practical guide created by power users to help you get the most out of Mica, fast."
  },
  {
    question: "Do I need advanced Excel skills?",
    answer: "No. If you can open Excel, you're ready."
  },
  {
    question: "Is this a subscription?",
    answer: "No. One-time payment."
  },
  {
    question: "How long does it take to complete the course?",
    answer: "You can finish it in one sitting, or go at your own pace. The course is designed to be concise and get you results fast."
  },
  {
    question: "What if I have questions as I'm going through the courses?",
    answer: "Feel free to contact us at support@mindlink.work and we'll be happy to help."
  }
];

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq section">
      <div className="container">
        <h2 className="section-title">Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <button 
                className="faq-question"
                onClick={() => toggleFAQ(index)}
              >
                <span>{faq.question}</span>
                <svg 
                  className={`faq-icon ${openIndex === index ? 'open' : ''}`}
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2"
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </button>
              {openIndex === index && (
                <div className="faq-answer">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQ;
